import React from 'react';

import { translate } from '@vimeo/i18n-runtime';

const T = {
  AddToCalendar: translate('Add to calendar'),
  AllowCookies: translate('Allow cookies'),
  Continue: translate('Continue'),
  ContinueToSignIn: translate('Continue to sign in'),
  InvalidEmailAddress: translate('Enter a valid email address'),
  SignIn: translate('Sign in'),
  MultiStep: translate('Multi-step form'),
  OptingInIsRequired: translate('Opt in to continue'),
  PrivateVideo: translate('Private Video'),
  RegistrationFullMessage: translate('Sorry, registration is full.'),
  RegisterToSignIn: translate('Register first to sign in'),
  SignInWithSSO: translate('Sign in with SSO'),
  SignIntoVimeo: translate('Sign into Vimeo'),
  SignIntoVimeoToWatch: translate('Sign into Vimeo to watch this video'),
  SingleStep: translate('Single-step form'),
  SkipToVideo: translate('Skip to video'),
  SorryNoPermission: translate("Sorry, you don't have permission to watch."),
  StepXofY: (STEP: number, STEPS: number) =>
    translate({
      singular: 'Step {STEP} of {STEPS}',
      replacements: { STEP, STEPS },
    }),
  ThisFieldIsRequired: translate('This field is required.'),
  ThisVideoIsPrivate: translate('This video is private. Sign in to watch.'),
  TryWatchingOnVimeo: translate('Try watching on vimeo.com.'),
  UhOhThereWasAProblem: translate('Uh oh. There was a problem. Please try again.'),
  VideoUnavailable: translate('Video unavailable'),
  VideoWillPlayIn: (TIMER: number) =>
    translate({
      singular: 'Video will play in {TIMER}',
      replacements: { TIMER },
    }),
  WatchOnVimeo: translate('Watch on Vimeo'),
  YouMayNeedToAllowCookies: translate({
    singular:
      'You may need to allow cookies first. If asked, select {BOLD}Allow{/BOLD} to continue.',
    replacements: {
      BOLD: (children: string) => <b>{children}</b>,
    },
  }),
  YouMaySignInToWatch: translate('You may sign in to watch this video.'),
  YourBrowserWillAskToAllowCookies: translate({
    singular:
      'Your browser will ask if you want to allow cookies. Select {BOLD}Allow{/BOLD} to continue.',
    replacements: {
      BOLD: (children: string) => <b>{children}</b>,
    },
  }),
};

export default T;
